import { render, staticRenderFns } from "./detail-tab-acoes.vue?vue&type=template&id=8dc44c70&"
import script from "./detail-tab-acoes.vue?vue&type=script&lang=js&"
export * from "./detail-tab-acoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8dc44c70')) {
      api.createRecord('8dc44c70', component.options)
    } else {
      api.reload('8dc44c70', component.options)
    }
    module.hot.accept("./detail-tab-acoes.vue?vue&type=template&id=8dc44c70&", function () {
      api.rerender('8dc44c70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/crm/components/detail-tab-acoes/detail-tab-acoes.vue"
export default component.exports